import React from 'react';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import CellChipStatus from './CellChipStatus';

interface CellRunLogStatusWithRetryProps {
  params: any;
  onClick: (params: any, clickedElement?: string) => void;
  children: React.ReactNode;
}

const CellRunLogStatusWithRetry = ({
  params,
  onClick,
  children,
}: CellRunLogStatusWithRetryProps) => {
  const statusValue = String(children ?? '').trim().toLowerCase();
  const isFailed = statusValue === 'failed';
  const isRetrying = Boolean(params?.row?.__retrying);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <CellChipStatus>{children}</CellChipStatus>
      {isFailed && (
        <Tooltip title={isRetrying ? 'Retrying...' : 'Retry'}>
          <span>
            <IconButton
              size="small"
              onClick={event => {
                event.stopPropagation();
                onClick(params, 'retry');
              }}
              disabled={isRetrying}
              aria-label="retry run log"
            >
              {isRetrying ? <CircularProgress size={16} thickness={5} /> : <ReplayIcon fontSize="small" />}
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};

export default CellRunLogStatusWithRetry;
